import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { NumberCardsService } from '../number-cards.service';
import { Location } from '@angular/common';
import { SuperExerciseComponent } from '../super-exercise/super-exercise.component';
import { MessageService } from '../../shared/message.service';


@Component({
  selector: 'app-position-card',
  templateUrl: './position-card.component.html',
  styleUrls: ['../topic-style.css', './position-card.component.css']
})
export class PositionCardComponent extends SuperExerciseComponent {

  //typespecifics
  showImmediateHelp: Boolean;
  showComputation: Boolean;

  private showFeedback: boolean = false;
  private feedbackType: string;

  constructor(protected numberCardsService: NumberCardsService, protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService) {
    super(numberCardsService, activatedRoute, topicService, messageService);
  }

  /** set the typespecific information based on the configuration*/
  setTypeSpecificsFromConfiguration() {
    super.setTypeSpecificsFromConfiguration();
    let typespecs = this.configuration["typespecifics"];
    this.requestedNumber = typespecs["requestedNumber"];
    this.count = this.numberCardsService.getCount(this.cards);
    this.solution = this.numberCardsService.getSolution(this.requestedNumber, this.cards);
    this.showImmediateHelp = typespecs["showImmediateHelp"];
    this.showComputation = typespecs["showComputation"];
  }

  /** returns the value of the current representation */
  value() {
    return this.numberCardsService.getValue(this.count);
  }

  /** returns the remainder of the current positionRepresentation */
  remainder() {
    return this.requestedNumber - this.value();
  }

  /** checks, whether the solution is correct or not */
  checkSolution(): void {
    let error = false;
    this.error = [];
    this.feedback = "";
    for (let i = 0; i < this.cards.length; i++) {
      if (this.solution[i] != this.count[this.cards[i]]) {
        error = true;
        if (this.showSymbols) {
          this.error.push(this.cards[i]);
        }
        if (this.showHelptext) {
          if (this.solution[i] > this.count[this.cards[i]]) {
            this.feedback = this.feedback.concat(this.get("tooFewCards"), " ", (new Number(this.cards[i])).toString(10), "\n");
          } else {
            this.feedback = this.feedback.concat(this.get("tooManyCards"), " ", (new Number(this.cards[i])).toString(), "\n");
          }
        }
      }
    }
    if (error) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer").concat("\n", this.feedback.toString()), "danger", 10000);
    } else {
      this.solved = true;
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();

    }
  }

  /** computes the immediate help text for the given card value */
  getImmediateHelp(card: number): string {
    if (this.count[card] < this.solution[this.cards.indexOf(card)]) {
      return this.get("tooFew");
    }
    if (this.count[card] > this.solution[this.cards.indexOf(card)]) {
      return this.get("tooMany");
    }
    return "";
  }

  /** evaluates the current state of the exercise 
    * @returns {number} - returns the total number of points (unweigthed, the maximum is 1)
   */
  evaluate(): number[] {
    let result = 0;
    if (this.numberCardsService.getValue(this.count) == this.requestedNumber) {
      result = 0.5;
    }
    
    let error = false;
    for (let i = 0; i < this.cards.length; i++) {
      if (this.solution[i] != this.count[this.cards[i]]) {
        error = true;
      }
    }
    if (!error) {
      result += 0.5;
    }
    return [2*result,2];
  }
}
